export default __webpack_public_path__ + "static/SR USA - Allergen - Statement-944ecc59c289c1408837bc8f1a1ab3da.pdf";